// GPS speed across all Pathfinder sources (vehicle CANedge3 GNSS, Android
// Location.getSpeed, Apple CLLocation.speed) is stored in metres per second.
// COP renders speed in mph, so convert only at the display boundary — state,
// analytics thresholds, and the DB stay in canonical m/s.
export const MPS_TO_MPH = 2.23694;

export function mpsToMph(speedMps: number): number {
  return speedMps * MPS_TO_MPH;
}

/** Format a canonical m/s speed as an mph string, e.g. "20.0 mph". */
export function formatSpeedMph(speedMps: number, digits = 1): string {
  return `${mpsToMph(speedMps).toFixed(digits)} mph`;
}
